/**
 * Tres Commas campaigns → picker options, sorted by name. Search matches the
 * name and the full id; a linked id missing from the list stays selectable so
 * opening the dialog never silently drops the current link.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { SearchableSelectOption } from '@/components/ui';
import type { TresCommasCampaign } from '@/hooks';

function toOption(campaign: TresCommasCampaign): SearchableSelectOption<string> {
  const name = campaign.name?.trim();
  return {
    value: campaign.id,
    label: name ? `${name} · ${campaign.id}` : campaign.id,
    triggerContent: name || campaign.id,
  };
}

export function tresCommasCampaignOptions(
  campaigns: readonly TresCommasCampaign[] | undefined,
  currentId: string,
): SearchableSelectOption<string>[] {
  const options = (campaigns ?? [])
    .filter((c) => typeof c.id === 'string' && c.id.trim() !== '')
    .map(toOption)
    .sort((a, b) => a.label.localeCompare(b.label));
  const current = currentId.trim();
  if (current === '' || options.some((o) => o.value === current)) return options;
  return [{ value: current, label: current, triggerContent: current }, ...options];
}
